import { combineReducers } from '@reduxjs/toolkit';
import contextSlice from './contextSlice';
import apiSlice from './apiSlice';

const rootReducer = combineReducers({
    context: contextSlice,
    api: apiSlice
});

export default rootReducer;